import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/common/ui/Button";
import { SelectInput } from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { logReportAction, masterActions } from "../../_store";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import CustomLoader from "../../components/common/ui/Loader";
import BanIcon from "../../assets/KioBan.png";
import generateXlsx from "../../components/common/export/generateXlsx";
import { formatDateTimeAMPM } from "../../utils/formatTime";


function KIOSKReport() {
  const {
    loading,
    // FacilityList: facilityOpts,
    PODList,
    KioskList,
    loadInactivekiosk,
    loadInactivekioskFullList: excelData,
  } = useSelector((x) => x.logReport);

  const { facilityDropDown: facilityOpts } = useSelector(
    (state) => state.master
  );

  const { Alerttype } = useSelector((x) => x.dropdownOptions);
  const dispatch = useDispatch();
  const [showalertTypes, setshowalertTypes] = useState(false);
  const [showSearchFields, setShowSearchFields] = useState(false);

  const [Logreport, setLogreport] = useState({
    FacilityID: 0,
    KiosksID: 0,
    PodID: 0,
    Alerttype: 4,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });
  const [scheduleCreatedDate, setScheduleCreatedDate] = useState("");
  const sortingRef = useRef(false);

  useEffect(() => {
    if (loadInactivekiosk?.DataList?.length > 0) {
      setScheduleCreatedDate(
        `Last Scheduler Run Time: ${formatDateTimeAMPM(
          loadInactivekiosk?.DataList[0]?.CreatedDate
        )}`
      );
    }
  }, [loadInactivekiosk]);

  useEffect(() => {
    dispatch(logReportAction.LoadInactivekiosk(Logreport));
  }, [Logreport]);

  // Initial Load (clean)
  useEffect(() => {
    dispatch(masterActions.LoadFacilityDropDown());
  }, []);


  // POD Load (only when Facility changes)
  useEffect(() => {
    dispatch(logReportAction.GetPODWithoutFacilityList(Logreport.FacilityID));
  }, [Logreport.FacilityID]);

  //Kiosk Load (only when Facility/Pod changes)
  useEffect(() => {
    dispatch(
      logReportAction.GetKioskWithoutFacilityList({
        podId: Logreport.PodID || 0,
        FaciltiyId: Logreport.FacilityID || 0,
      })
    );
  }, [Logreport.PodID, Logreport.FacilityID]);


  //Columns For Table
  const columns = [
    {
      name: "Facility Code",
      key: "FacilityCode",
      selector: (row) => row.FacilityCode,
      sortable: true,
    },
    {
      name: "Kiosk Code",
      key: "KioskCode",
      selector: (row) => row.KioskCode,
      sortable: true,
    },
    {
      name: "POD",
      key: "PODCode",
      selector: (row) => row.PODCode,
      sortable: true,
    },

    {
      width: "180px",
      name: "Login Date",
      key: "LoginDate",
      selector: (row) => (
        <div className="d-flex flex-wrap align-items-center gap-1">
          {row.LoginDate &&
            (row.IsLoginValid === 1 ? (
              <div className="user-batch button-success"></div>
            ) : (
              <div className="user-batch button-primary"></div>
            ))}
          {row.LoginDate}
        </div>
      ),
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            <div className="d-flex flex-wrap align-items-center gap-1">
              {row.LoginDate &&
                (row.IsLoginValid === 1 ? (
                  <div className="user-batch button-success"></div>
                ) : (
                  <div className="user-batch button-primary"></div>
                ))}
              {row.LoginDate}
            </div>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Inactive Duration",
      selector: (row) => row.HoursInactive, // Extracts the value for sorting purposes
      cell: (row) => row.HoursInactive,
      sortable: false,
    },

    {
      name: "Alert Type",
      selector: (row) => (
        <>
          {row.AlertType === "1" && (
            <div className="greenflag">
              <i className="fa-solid fa-clock clock-icon"></i>
            </div>
          )}
          {row.AlertType === "2" && (
            <div className="grayflag">
              <i className="fa-solid fa-clock clock-icon"></i>
            </div>
          )}
          {row.AlertType === "3" && (
            <div className="orangeflag">
              <i className="fa-solid fa-clock clock-icon"></i>
            </div>
          )}
          {row.AlertType === "4" && (
            <div className="redflag">
              <i className="fa-solid fa-clock clock-icon"></i>
            </div>
          )}
          {row.AlertType === "5" && <img src={BanIcon} alt="NOT IN USE" />}
          {row.AlertType === "6" && (
            <div className="yellowflag">
              <i className="fa-solid fa-clock clock-icon"></i>
            </div>
          )}
          {row.AlertType === "7" && (
            <div className="blackflag">
              <i className="fa-solid fa-clock clock-icon"></i>
            </div>
          )}
          {row.AlertType === "8" && (
            <div className="indigoflag">
              <i className="fa-solid fa-clock clock-icon"></i>
            </div>
          )}
        </>
      ),
      sortable: false,
      // center: true,
    },
  ];


  const handleSelectChange = (option, name) => {
    setLogreport((prev) => {
      let updated = { ...prev };

      switch (name) {
        case "FacilityID":
          updated = {
            ...updated,
            FacilityID: option?.value || 0,
            PodID: 0,
            KiosksID: 0,
            PageNo: 1,
          };
          break;

        case "PodID":
          updated = {
            ...updated,
            PodID: option?.value || 0,
            KiosksID: 0,
            PageNo: 1,
          };
          break;

        case "KiosksID":
          updated.KiosksID = option?.value || 0;
          break;

        case "Alerttype":
          updated.Alerttype = option?.value ?? 4;
          break;

        default:
          break;
      }

      return updated;
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();

    setLogreport((prev) => ({
      ...prev,
      PageNo: 1,
    }));
  };

  const handleReset = () => {
    setLogreport({
      FacilityID: 0,
      KiosksID: 0,
      PodID: 0,
      Alerttype: 4,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "",
    });
  };

  //sorting
  let sorting = false; // to restrict the pagination issue

  const handleSort = (column) => {
    if (!column?.key) return;

    sortingRef.current = true;

    setLogreport((prev) => {
      const isSame = prev.SortField.includes(column.key);
      const direction = isSame && prev.SortField.endsWith("asc") ? "desc" : "asc";

      return {
        ...prev,
        SortField: `${column.key} ${direction}`,
      };
    });
  };

  //Pagination
  const handlePageChange = (value) => {
    if (sortingRef.current) {
      sortingRef.current = false;
      return;
    }

    setLogreport((prev) => ({
      ...prev,
      PageNo: value,
    }));
  };

  const handleRowPerPage = (value) => {
    setLogreport((prev) => ({
      ...prev,
      RowCountPerPage: value,
      PageNo: 1,
    }));
  };

  //Excel

  useEffect(() => {
    if (excelData && excelData?.DataList?.length > 0) {
      const title = "InActiveKiosk";
      const generateExcelColumns = [
        "Facility Code",
        "Kiosk Code",
        "POD",
        "Login Date",
        "Inactive Duration",
        "Alert Type",
      ];

      const alertTypeMapping = {
        1: "Less than an Hour",
        2: "More than an Hour",
        3: "More than 3 Hours",
        4: "More than 4 Hours",
        5: "Not in Use",
        6: "Less than Half an Hour",
        7: "More than 24 Hours",
        8: "More than 24 Hours - Not in Use",
      };

      const excelExportData = excelData?.DataList?.map((obj) => ({
        FacilityCode: obj.FacilityCode,
        KioskCode: obj.KioskCode,
        PODCode: obj.PODCode,
        LoginDate: obj.LoginDate,
        HoursInactive: obj.HoursInactive,
        AlertType1: alertTypeMapping[obj.AlertType] || "",
      }));

      // Generate the Excel file with the transformed data

      try {
        generateXlsx(excelExportData, generateExcelColumns, title);
        dispatch(logReportAction.clearexcelData());
      } catch (error) { }
    }
  }, [excelData]);

  const handleExcel = () => {
    let updatedParam = {
      ...Logreport,
      PageNo: 1,
      RowCountPerPage: loadInactivekiosk.TotalRecordCount,
      exportExcel: true,
    };
    dispatch(logReportAction.LoadInactivekiosk(updatedParam));
  };

  if (loading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setshowalertTypes((prev) => !prev);
  };

  const renderAlertTypefirst = () => {
    return (
      <div className="col-12 d-flex flex-wrap">
        <div className="div-log">
          <div className="me-4">
            <div className="d-flex flex-wrap align-items-center gap-1">
              <div className="user-batch button-success"></div>
              <span className="ms-2">Inmate Login</span>
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center gap-1">
            <div className="user-batch button-primary"></div>
            <span className="ms-2">Auto Login</span>
          </div>
        </div>
      </div>
    );
  };
  const renderAlertType = () => {
    return (
      <div className="col-12 d-flex flex-wrap">
        <div className="log-report-width d-flex flex-wrap align-items-center me-2 mb-2">
          {/* <img src={YellowIcon} alt="" /> */}
          <div className="yellowflag">
            <i className="fa-solid fa-clock clock-icon"></i>
          </div>
          <span className="ms-2 report-style">Less than Half an Hour</span>
        </div>
        <div className="log-report-width d-flex flex-wrap align-items-center me-2 mb-2">
          {/* <img src={GreenIcon} alt="" /> */}
          <div className="greenflag">
            <i className="fa-solid fa-clock clock-icon"></i>
          </div>
          <span className="ms-2 report-style">Less than an Hour</span>
        </div>
        <div className="log-report-width d-flex flex-wrap align-items-center me-2 mb-2">
          {/* <img src={GreyIcon} alt="" /> */}
          <div className="grayflag">
            <i className="fa-solid fa-clock clock-icon"></i>
          </div>
          <span className="ms-2 report-style">More than an Hour</span>
        </div>
        <div className="log-report-width d-flex flex-wrap align-items-center me-2 mb-2">
          {/* <img src={OrangeIcon} alt="" /> */}
          <div className="orangeflag">
            <i className="fa-solid fa-clock clock-icon"></i>
          </div>
          <span className="ms-2 report-style">More than 3 Hours</span>
        </div>
        <div className="log-report-width d-flex flex-wrap align-items-center me-2 mb-2">
          {/* <img src={RedIcon} alt="" />    */}
          <div className="redflag">
            <i className="fa-solid fa-clock clock-icon"></i>
          </div>
          <span className="ms-2 report-style">More than 4 Hours</span>
        </div>
        <div className="log-report-width d-flex flex-wrap align-items-center me-2 mb-2">
          {/* <img src={BlackIcon} alt="" /> */}
          <div className="blackflag">
            <i className="fa-solid fa-clock clock-icon"></i>
          </div>
          <span className="ms-2 report-style">More than 24 Hours</span>
        </div>
        <div className="log-report-width d-flex flex-wrap align-items-center me-2 mb-2">
          {/* <img src={IndigoIcon} alt="" /> */}
          <div className="indigoflag">
            <i className="fa-solid fa-clock clock-icon"></i>
          </div>
          <span className="ms-2 report-style">
            More than 24 Hours - Not in Use
          </span>
        </div>
        <div className="log-report-width d-flex flex-wrap align-items-center me-2 mb-2">
          <img src={BanIcon} alt="" width={18} height={18} />
          <span className="ms-2 report-style">Not in Use</span>
        </div>
      </div>
    );
  };
  const toggleInformationTab = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <SelectInput
                name="facilityID"
                label="Facility Code"
                options={facilityOpts}
                value={Logreport?.FacilityID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "FacilityID")
                }
                isMulti={false}
                isClearable={Logreport?.FacilityID ? true : false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <SelectInput
                name="PodID"
                label="POD"
                options={PODList}
                value={Logreport?.PodID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "PodID")
                }
                isMulti={false}
                isClearable={Logreport?.PodID ? true : false}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <SelectInput
                name="KiosksID"
                label="Kiosk Code"
                options={KioskList}
                value={Logreport?.KiosksID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "KiosksID")
                }
                isMulti={false}
                isClearable={Logreport?.KiosksID ? true : false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <SelectInput
                name="Alerttype"
                label="Alert Type"
                options={Alerttype}
                value={Logreport?.Alerttype}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "Alerttype")
                }
                isMulti={false}
                isClearable={Logreport?.Alerttype !== 4}
              />
            </div>
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            status="primary"
            icon={"search"}
            onClick={handleSearch}
          />
          <Button
            className="me-2"
            label="Reset"
            icon={"fa-solid fa-rotate-right"}
            type="button"
            status="secondary"
            onClick={handleReset}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformationTab}
          >
            <h2 className="form_title_uppercase text-color">
              InActive-Kiosk Search
            </h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">
            InActive-Kiosk Search
          </h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block ">{renderSearch()}</div>
      </div>

      <div className="mt-5">
        <div className="">
          <div className="log-report d-flex flex-wrap log-report">
            <div className="ms-auto d-flex flex-wrap">
              <strong> {scheduleCreatedDate}</strong>
            </div>
          </div>

          {/* Left Side Icons */}
          {loadInactivekiosk?.DataList?.length > 0 && (
            <div className="row gy-2 mb-3">
              {/* First Line */}

              <div className="col-12 d-flex flex-wrap justify-content-between align-items-center resp-space">
                <h2 className="form_title_uppercase text-color">
                  InActive-Kiosks List
                </h2>


                <div className="">
                  {/* Right-aligned Export Button */}
                  <div className="ms-auto d-flex flex-wrap gap-3 align-items-center">
                    {loadInactivekiosk?.DataList?.length > 0 && (
                      <ExcelExport handleExcelExport={handleExcel} />
                    )}
                  </div>
                </div>
              </div>
              <div className="d-block d-md-none">
                {renderAlertTypefirst()}
              </div>
              {/* Right Side Export to Excel */}
              <div className="d-none d-md-block">{renderAlertTypefirst()}</div>
              {/* Second Line */}
              <div className="d-none d-md-block">{renderAlertType()}</div>

              {/* Mobile only (Below md breakpoint) */}
              <div className=" d-block d-md-none card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
                <div className=" d-block d-md-none">
                  <div
                    className=" d-flex align-items-center justify-content-between"
                    style={{ background: "transparent", cursor: "pointer" }}
                    onClick={toggleInformation}
                  >
                    <h2 className="form_title_uppercase text-color">
                      Alert Type
                    </h2>
                    <i
                      id="itagInformation"
                      className={`fa fa-angle-down ${showalertTypes ? "rotate" : ""
                        }`}
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
                <div className=" mt-2 d-block d-md-none">
                  {showalertTypes && renderAlertType()}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Table */}
        <Table
          columns={columns}
          data={loadInactivekiosk?.DataList}
          pagination={true}
          onChangePage={(e) => handlePageChange(e)} // Call API when page changes
          onChangeRowsPerPage={(e) => handleRowPerPage(e)}
          totalRowCount={loadInactivekiosk?.TotalRecordCount}
          currentPage={Logreport?.PageNo}
          paginationPerPage={Logreport?.RowCountPerPage}
          serverSideSort
          onSort={handleSort}
          sortColumn={Logreport?.SortField?.split(" ")[0]}
          sortDirection={Logreport?.SortField?.split(" ")[1]}
        />
      </div>
    </div>
  );
}

export default React.memo(KIOSKReport);
